export const ACCESS_SUBSCRIPTION_STATUSES = Object.freeze(["active", "trialing"]);

export function normalizeSubscriptionStatus(value) {
  return String(value || "inactive").trim().toLowerCase() || "inactive";
}

export function hasSubscriptionAccess(account = {}) {
  if (account.subscriptionStatus !== undefined && account.subscriptionStatus !== null) {
    return ACCESS_SUBSCRIPTION_STATUSES.includes(normalizeSubscriptionStatus(account.subscriptionStatus));
  }
  // Temporary migration fallback for accounts created before normalized Stripe state.
  return account.subscription === true || account.subscription === "true";
}

export function applySubscriptionEntitlements(store, account = {}) {
  const active = hasSubscriptionAccess(account);
  store.state.hasSubscribed = active;
  store.state.subscriptionStatus = normalizeSubscriptionStatus(
    account.subscriptionStatus ?? (active ? "active" : "inactive")
  );
  return active;
}
